import React from "react"

export const MENTION_PATTERN = /@\[([^\]]+)\]\(([^)]+)\)/g

export const NoteWithMentions = ({ text, mentions = [] }) => {
  const renderTextWithMentions = () => {
    if (!text) {
      return null
    }

    if (!mentions || mentions.length === 0) {
      return <span>{text}</span>
    }

    const matches = Array.from(text.matchAll(MENTION_PATTERN))

    if (matches.length === 0) {
      return <span>{text}</span>
    }

    const parts = []
    let lastIndex = 0

    matches.forEach((match) => {
      if (match.index > lastIndex) {
        const textBefore = text.substring(lastIndex, match.index)
        parts.push(
          <span key={`text-${lastIndex}-${match.index}`}>
            {textBefore}
          </span>
        )
      }

      const mentionName = match[1]
      const mentionId = match[2]

      parts.push(
        <span
          key={`mention-${match.index}-${mentionId}`}
          className="inline-flex items-center px-2 py-0.5 mx-1 text-sm font-medium text-primary-main bg-primary-main/10 rounded-full border border-primary-main/20"
          title={`@${mentionName}`}
        >
          @{mentionName}
        </span>
      )

      lastIndex = match.index + match[0].length
    })

    if (lastIndex < text.length) {
      const remainingText = text.substring(lastIndex)
      parts.push(
        <span key={`text-${lastIndex}-end`}>
          {remainingText}
        </span>
      )
    }

    return parts
  }

  return (
    <div className="whitespace-pre-wrap break-words w-full leading-normal">
      {renderTextWithMentions()}
    </div>
  )
}